import moment from "moment";
import "moment/locale/it";

const DATE_FORMAT = "YYYY-MM-DD";

/** Il locale italiano di Moment produce giorni e mesi minuscoli. */
export const capitalizeLabel = (value) =>
  String(value).replace(/(^|\s)([a-z])/g, (match, prefix, letter) => prefix + letter.toUpperCase());

export const buildMonthDays = (month, today) => {
  if (!moment.isMoment(month) || !month.isValid()) return [];
  const currentDay = moment(today, DATE_FORMAT, true);
  if (!currentDay.isValid()) return [];

  const selectedMonth = month.clone().startOf("month");
  if (selectedMonth.isAfter(currentDay, "month")) return [];

  const lastDay = selectedMonth.isSame(currentDay, "month")
    ? currentDay.clone()
    : selectedMonth.clone().endOf("month");
  const days = [];
  for (let day = lastDay; day.isSame(selectedMonth, "month"); day.subtract(1, "day")) {
    const localizedDay = day.clone().locale("it");
    const weekday = localizedDay.day();
    days.push({
      date: localizedDay.format(DATE_FORMAT),
      weekday: localizedDay.format("dddd"),
      label: localizedDay.format("D MMMM YYYY"),
      isWeekend: weekday === 0 || weekday === 6,
    });
  }
  return days;
};

export const groupActivitiesByDate = (items) => {
  const groups = (Array.isArray(items) ? items : []).reduce((result, item) => {
    if (!item || typeof item.date !== "string") return result;
    if (!result[item.date]) result[item.date] = [];
    result[item.date].push(item);
    return result;
  }, {});
  /** Anche dentro la giornata l'ordine è decrescente: prima le attività più recenti. */
  Object.keys(groups).forEach((date) => {
    groups[date].sort((left, right) => Number(right.id) - Number(left.id));
  });
  return groups;
};
